import {Button} from "../ui-components/button.tsx";
import {useNavigate} from "react-router-dom";
import {FC} from "react";
import {LightButton} from "./buttons/LightButton.tsx";
import clsx from "clsx";

export const ButtonsBottomBlockOfPage: FC<{
    title1: string,
    title2: string,
    type?: 'submit'
    shadow?: boolean
    continueFunc?: () => void,
    onClickBack?: () => void
}> = ({title1, title2, onClickBack, continueFunc, type, shadow}) => {
    const navigate = useNavigate();
    const navigateToStep2 = () => {
        navigate(-1)
    }
    return (
        <div className={clsx(`w-full absolute left-0 bottom-0 pb-6`, {
                "custom-gradient": shadow
            })}>
            <div className={clsx(`flex relative gap-6 z-10 w-full px-[16px]`)}>
                <LightButton title={title1} onClick={onClickBack ?? navigateToStep2}/>
                <Button color={"dark/white"}
                        type={type || 'button'}
                        onClick={continueFunc || navigateToStep2}
                        className={"py-[10px] w-full !text-sm !font-semibold !text-white rounded-lg box-shadow overflow-hidden"}>
                    {title2}
                </Button>
            </div>
        </div>

    )
}